export var FormApiEndpoint;
(function (FormApiEndpoint) {
    FormApiEndpoint["CalculateDueDate"] = "due";
    FormApiEndpoint["GetFiles"] = "files/";
    FormApiEndpoint["GetFormByStatus"] = "get/";
    FormApiEndpoint["SyncForm"] = "sync/";
    FormApiEndpoint["UpdateRequest"] = "update/";
    FormApiEndpoint["Unlock"] = "unlock/";
})(FormApiEndpoint || (FormApiEndpoint = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9ybS5hcGktZW5kcG9pbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJmb3JtLmFwaS1lbmRwb2ludC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQU4sSUFBWSxlQU9YO0FBUEQsV0FBWSxlQUFlO0lBQ3ZCLDJDQUF3QixDQUFBO0lBQ3hCLHNDQUFtQixDQUFBO0lBQ25CLDJDQUF3QixDQUFBO0lBQ3hCLHFDQUFrQixDQUFBO0lBQ2xCLDRDQUF5QixDQUFBO0lBQ3pCLHFDQUFrQixDQUFBO0FBQ3RCLENBQUMsRUFQVyxlQUFlLEtBQWYsZUFBZSxRQU8xQiJ9